import { render, staticRenderFns } from "./ShootingScore.vue?vue&type=template&id=ed9e1ff6"
import script from "./ShootingScore.vue?vue&type=script&lang=js"
export * from "./ShootingScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports